export const pressRu = [
  {
    text:
      'Роман «Падение»: напряженный триллер про самолет. Бортпроводница написала его на салфетках',
    link:
      'https://journal.bookmate.com/roman-padenie-napryazhennyj-triller-pro-samolet-bortprovodnica-napisala-ego-na-salfetkah/',
    date: '27 мая 2022',
    type: 'press',
  },
  {
    text:
      'Российские издательства открыли бесплатный доступ к некоторым книгам на Bookmate',
    link: 'https://tass.ru/obschestvo/14353079',
    date: '12 апреля 2022',
    type: 'press',
  },
  {
    source: 'Москвич Mag',
    text:
      '«Больше аудиокниг слушают, когда на улице холодно» — директор Bookmate Андрей Баев',
    link:
      'https://moskvichmag.ru/lyudi/bolshe-audioknig-slushayut-kogda-na-ulitse-holodno-direktor-bookmate-andrej-baev/',
    date: '08 февраля 2022',
    type: 'press',
  },
  {
    source: 'РИА Новости',
    text:
      'Дебютный роман Тарантино "Однажды в Голливуде" выйдет в России в полночь 26 ноября',
    link: 'https://ria.ru/20211125/tarantino-1760705109.html',
    date: '25 ноября 2021',
    type: 'press',
  },
  {
    source: 'vc.ru',
    text:
      'Россияне предпочитают слушать книги без ускорения и делают перерыв на выходных — исследование на пользователях Bookmate',
    link:
      'https://vc.ru/services/316247-rossiyane-predpochitayut-slushat-knigi-bez-uskoreniya-i-delayut-pereryv-na-vyhodnyh-issledovanie-na-polzovatelyah-bookmate',
    date: '08 ноября 2021',
    type: 'press',
  },
  {
    source: 'Афиша Daily',
    text:
      '«Кожа» Евгении Некрасовой: аудиосериал о рабстве, крепостничестве и свободе',
    link:
      'https://daily.afisha.ru/brain/20671-kozha-evgenii-nekrasovoy-audioserial-o-rabstve-krepostnichestve-i-svobode/',
    date: '26 августа 2021',
    type: 'press',
  },
  {
    source: 'сolta.ru',
    text: 'Саундтрек от кометы Галлея',
    link:
      'https://www.colta.ru/articles/music_modern/28017-georgiy-slugin-knizhnyy-serial-vozvraschenie-pionera-shamil-idiatullin-saundtrek-zvukovaya-laboratoriya-kotae',
    date: '13 августа 2021',
    type: 'press',
  },
  {
    source: 'Buro24/7',
    text:
      'Писательница Евгения Некрасова и Bookmate Originals запустили книжный сериал «Кожа». Саундтрек создала группа АИГЕЛ',
    link:
      'https://www.buro247.ru/news/culture/3-jun-2021-evgenia-nekrasova-bookmate-series-skin.html',
    date: '03 июня 2021',
    type: 'press',
  },
  {
    source: 'Год литературы',
    text: 'Яндекс.Учебник и Bookmate открыли доступ к подборке «Книги на лето»',
    link:
      'https://godliteratury.ru/articles/2021/05/31/iandeksuchebnik-i-bookmate-otkryli-dostup-k-podborke-knigi-na-leto',
    date: '31 мая 2021',
    type: 'press',
  },
  {
    source: 'Republic',
    text:
      'Алексей Докучаев: «Возможно, проблема России в том, что люди не знают, зачем им читать»',
    link: 'https://republic.ru/posts/99957',
    date: '17 мая 2021',
    type: 'press',
  },
  {
    source: 'РБК',
    text:
      'Телекинез и будущее без работы: что почитать про искусственный интеллект',
    link: 'https://trends.rbc.ru/trends/industry/608672489a7947716f2c07d4',
    date: '26 апреля 2021',
    type: 'press',
  },
  {
    source: 'The Village',
    text: 'Андрей Баев: «Люди сидят дома и читают книги, как не сойти с ума»',
    link: 'https://www.the-village.ru/business/interview/bukmeyt',
    date: '29 октября 2020',
    type: 'press',
  },
  {
    source: 'Type.Today',
    text:
      'Максим Балабин: «Чтение — самый простой способ запихнуть информацию в голову»',
    link: 'https://type.today/ru/journal/balabin',
    date: '24 сентября 2020',
    type: 'press',
  },
  {
    source: 'Новая газета',
    text:
      'Новая Антигона. Документальная пьеса о суде над мамами Беслана сегодня опубликована на крупнейшем книжном сервисе Bookmate',
    link: 'https://novayagazeta.ru/articles/2020/09/03/86946-novaya-antigona',
    date: '03 сентября 2020',
    type: 'press',
  },
  {
    source: 'Афиша Daily',
    text:
      'Bookmate выпустил «Важные вещи» Елены Макеенко — путеводитель по современной русской прозе',
    link:
      'https://daily.afisha.ru/news/40263-bookmate-vypustil-vazhnye-veschi-eleny-makeenko-putevoditel-po-sovremennoy-russkoy-proze/',
    date: '11 августа 2020',
    type: 'press',
  },
  {
    source: 'BBC',
    text: '«Хиросима» Джона Херси впервые выходит на русском языке',
    link: 'https://www.bbc.com/russian/features-53652433',
    date: '5 августа 2020',
    type: 'press',
  },
  {
    source: 'Радио Sputnik',
    text:
      'Поздний вечер дома с книгой: как пандемия изменила привычки читателей',
    link: 'https://radiosputnik.ria.ru/20200724/1574854163.html',
    date: '24 июля 2020',
    type: 'press',
  },
  {
    source: 'Лайфхакер',
    text:
      '«Ты приносишь в жертву выдуманного человека, чтобы отвести беду от живых людей»: интервью с писателем Борисом Акуниным',
    link: 'https://lifehacker.ru/boris-akunin-interview/',
    date: '10 июля 2020',
    type: 'press',
  },
  {
    source: 'Buro24/7',
    text:
      'Что такое «нормальная семья» в России? Отвечает автор романа «Дни нашей жизни»',
    link:
      'https://www.buro247.ru/personality/children/2-jul-2020-normal-russian-family-by-mikita-franko.html',
    date: '02 июля 2020',
    type: 'press',
  },
  {
    source: 'vc.ru',
    text:
      'Подкаст о том, как Bookmate искал свою стилистику и что ждет growth-стартапы в ближайшем будущем',
    link:
      'https://vc.ru/media/138074-podkast-o-tom-kak-bookmate-iskal-svoyu-stilistiku-i-chto-zhdet-growth-startapy-v-blizhayshem-budushchem',
    date: '29 июня 2020',
    type: 'press',
  },
  {
    source: 'vc.ru',
    text:
      '«После 15 часов удалёнки в неделю уровень счастья перестаёт расти»: как работа вне офисов повлияла на Slack и других',
    link:
      'https://vc.ru/office/134918-posle-15-chasov-udalenki-v-nedelyu-uroven-schastya-perestaet-rasti-kak-rabota-vne-ofisov-povliyala-na-slack-i-drugih',
    date: '18 июня 2020',
    type: 'press',
  },
  {
    source: 'colta.ru',
    text: 'Выходит антология пьес «Театра.doc»',
    link: 'https://www.colta.ru/news/24398-vyhodit-antologiya-pies-teatra-doc',
    date: '16 мая 2020',
    type: 'press',
  },
  {
    source: 'РБК',
    text: 'Россияне стали больше читать про психическое и физическое здоровье ',
    link: 'https://trends.rbc.ru/trends/education/5eb6bf319a79479f9487d395',
    date: '09 мая 2020',
    type: 'press',
  },
  {
    source: 'Meduza',
    text:
      'Что почитать? Советуют Сергей Гуриев, Линор Горалик, Борис Акунин и другие',
    link:
      'https://meduza.io/games/chto-pochitat-sovetuyut-sergey-guriev-linor-goralik-boris-akunin-i-drugie',
    date: '15 апреля 2020',
    type: 'press',
  },
  {
    source: 'Esquire',
    text:
      'Людмила Улицкая — о своей рукописи «Чума», которая никогда не издавалась и сейчас обрела актуальность',
    link:
      'https://esquire.ru/hero/170863-lyudmila-ulickaya-o-svoey-rukopisi-chuma-kotoraya-nikogda-ne-izdavalas-i-seychas-obrela-aktualnost/',
    date: '14 апреля 2020',
    type: 'press',
  },
  {
    source: 'Телеканал Дождь',
    text:
      '«Его завещание — быть экстремально честным человеком». О чем посмертная книга Лимонова «Старик путешествует», и когда ее можно будет прочитать',
    link:
      'https://tvrain.ru/teleshow/here_and_now/posmertnaja_kniga_limonova-505638/',
    date: '28 марта 2020',
    type: 'press',
  },
  {
    source: 'Новая газета',
    text: 'Одобрено «Новой»: что мы рекомендуем прочитать на карантине',
    link: 'https://novayagazeta.ru/articles/2020/03/28/84554-odobreno-novoy',
    date: '28 марта 2020',
    type: 'press',
  },
  {
    source: 'sports.ru',
    text:
      '«Люди гибнут за «Спартак». Sports.ru и Bookmate запускают подкаст о деле братьев Старостиных',
    link: 'https://www.sports.ru/tribuna/blogs/lgzspordcast/',
    date: '21 марта 2020',
    type: 'press',
  },
  {
    source: 'Коммерсант',
    text: '«Эксмо-АСТ» сделала электронную копию',
    link: 'https://www.kommersant.ru/doc/4215468',
    date: '10 января 2020',
    type: 'press',
  },
  {
    source: 'Коммерсант',
    text: 'Электронные книги выпустят в прокат',
    link: 'https://www.kommersant.ru/doc/4205222',
    date: '23 декабря 2019',
    type: 'press',
  },
  {
    source: 'vc.ru',
    text:
      '«Билайн» запустил акцию «Гиги за мозги» и предложил дополнительный интернет за чтение книг на Bookmate',
    link:
      'https://vc.ru/marketing/71862-bilayn-zapustil-akciyu-gigi-za-mozgi-i-predlozhil-dopolnitelnyy-internet-za-chtenie-knig-na-bookmate',
    date: '17 июня 2019',
    type: 'press',
  },
  {
    source: 'The Village',
    text: 'Как продавать книги, когда вокруг пираты',
    link:
      'http://www.the-village.ru/village/business/businessmen/295018-bookmate',
    date: '19 декабря 2017',
    type: 'press',
  },
  {
    source: 'Канобу',
    text:
      'Bookmate теперь первое издательство электронных комиксов в России. Начинают со «Звездных войн»',
    link:
      'https://kanobu.ru/news/bookmate-teper-pervoe-izdatelstvo-elektronnyih-komiksov-vrossii-nachinayut-sozvezdnyih-vojn-399603',
    date: '1 декабря 2017',
    type: 'press',
  },
  {
    source: 'vc.ru',
    text: 'Bookmate стала совладельцем книжного издательства Individuum',
    link:
      'https://vc.ru/29835-bookmate-stala-sovladelcem-knizhnogo-izdatelstva-individuum',
    date: '29 ноября 2017',
    type: 'press',
  },
  {
    source: 'Forbes',
    text: 'Открытая книга: как книжный сервис завлекает читателей',
    link:
      'http://www.forbes.ru/kompanii/338055-otkrytaya-kniga-kak-knizhnyy-servis-zavlekaet-chitateley',
    date: '27 января 2017',
    type: 'press',
  },
  {
    source: 'vc.ru',
    text:
      'Сервис Bookmate вышел на рынок Дании и анонсировал появление аудиокниг',
    link: 'https://vc.ru/n/bookmate-audio',
    date: '26 января 2017',
    type: 'press',
  },
  {
    source: 'Секрет фирмы',
    text: '7 неожиданных фактов о том, как в России читают книги',
    link: 'http://secretmag.ru/article/2016/11/18/chtenie',
    date: '18 ноября 2016',
    type: 'press',
  },
  {
    source: 'Секрет фирмы',
    text:
      'Андрей Баев, Bookmate: «В мире мы на втором месте после Kindle Unlimited»',
    link: 'http://secretmag.ru/article/2016/06/07/andrej-baev-bookmate/',
    date: '8 июня 2016',
    type: 'press',
  },
  {
    source: 'Хабрахабр',
    text: 'Большое интервью Саймона Данлопа',
    link: 'https://habrahabr.ru/post/302252/',
    date: '31 мая 2016',
    type: 'press',
  },
  {
    source: 'Computerworld Казахстан',
    text: 'Самым популярным OTT‐сервисом Kcell оказался Bookmate от activ',
    link: 'http://www.computerworld.kz/articlekz/10257/',
    date: '21 мая 2016',
    type: 'press',
  },
  {
    source: 'Computerworld Казахстан',
    text: 'Глава Kcell Арти Отс удивлен успехом сервиса Bookmate by active',
    link: 'http://www.computerworld.kz/news/9840/',
    date: '1 марта 2016',
    type: 'press',
  },
  {
    source: 'CityDog.by',
    text: 'Как настоящие: в минском метро появились вагоны‐библиотеки',
    link: 'http://citydog.by/post/chitat-v-metro/',
    date: '7 декабря 2015',
    type: 'press',
  },
  {
    source: 'Секрет фирмы',
    text:
      '«Чтобы работать с сервисами, как Bookmate, американцам нужно ещё лет десять»',
    link: 'http://secretmag.ru/longread/2015/10/22/bookmate/',
    date: '22 октября 2015',
    type: 'press',
  },
  {
    source: 'Slon',
    text: 'Андрей Баев, Bookmate: «Книги стали альтернативой Angry Birds»',
    link: 'https://slon.ru/posts/57987',
    date: '14 октября 2015',
    type: 'press',
  },
  {
    source: 'Firrma',
    text: 'Bookmate вышел на рынок Индонезии',
    link: 'http://firrma.ru/data/news/5924/',
    date: '25 августа 2015',
    type: 'press',
  },
  {
    source: 'RUSBASE',
    text: 'Российский сервис Bookmate вышел на рынок Индонезии',
    link: 'http://rusbase.com/news/bookmate-enter-indonesia/',
    date: '25 августа 2015',
    type: 'press',
  },
  {
    source: 'Эксперт',
    text: 'Мобильное чтение',
    link: 'http://expert.ru/expert/2015/13/mobilnoe-chtenie/',
    date: '21 марта 2015',
    type: 'press',
  },
  {
    source: 'Apptractor',
    text:
      'Максим Балабин (Bookmate): будучи медиа, книга не слишком отличается от игры или фильма',
    link:
      'http://apptractor.ru/marketing-monetization/maksim-balabin-bookmate-buduchi-media-kniga-ne-slishkom-otlichaetsya-ot-igryi-ili-filma.html',
    date: '14 января 2015',
    type: 'press',
  },
  {
    source: 'Коммерсант',
    text: 'Bookmate вышел в Сингапур',
    link: 'http://www.kommersant.ru/doc/2640083',
    date: '24 декабря 2014',
    type: 'press',
  },
  {
    source: 'Apps4all',
    text: 'Bookmate',
    link: 'http://apps4all.ru/post/12-23-14-bookmate',
    date: '23 декабря 2014',
    type: 'press',
  },
  {
    source: 'Firrma',
    text: 'Bookmate начал международную экспансию',
    link: 'http://firrma.ru/data/news/4359/',
    date: '23 декабря 2014',
    type: 'press',
  },
  {
    source: 'The Village',
    text: '10 бизнес‐идей для кризиса',
    link:
      'http://www.the-village.ru/village/hopesandfears/management/172757-10-novyh-biznes-modeley-dlya-krizisa',
    date: '22 декабря 2014',
    type: 'press',
  },
  {
    source: 'Афиша-Воздух',
    text: 'Новое бедное. Как сэкономить на книгах, кино и театре',
    link: 'http://vozduh.afisha.ru/art/kak-sekonomit-na-knigah-kino-i-teatre/',
    date: '18 декабря 2014',
    type: 'press',
  },
  {
    source: 'itReviewer.ru',
    text: 'Клиентам «Билайн» станут доступны сервисы Bookmate и Zvooq',
    link:
      'http://itreviewer.ru/news/23760/klientam-bilajn-stanut-dostupny-servisy-bookmate-i-zvooq/',
    date: '12 декабря 2014',
    type: 'press',
  },
  {
    source: 'Look at Me',
    text: 'Вишлист: Выгодные подписки, которые упростят жизнь',
    link:
      'http://www.lookatme.ru/mag/live/inspiration-lists/210043-wishlist-subscription-services',
    date: '8 декабря 2014',
    type: 'press',
  },
  {
    source: 'Российская Газета',
    text: 'Утомленные non/fiction',
    link: 'http://www.rg.ru/2014/12/02/yarmarka.html',
    date: '2 декабря 2014',
    type: 'press',
  },
  {
    source: 'Москва 24',
    text: 'Цифра',
    link: 'http://www.m24.ru/videos/67079',
    date: '15 ноября 2014',
    type: 'press',
  },
  {
    source: 'Афиша-Воздух',
    text: '9 приложений октября',
    link: 'http://vozduh.afisha.ru/technology/9-prilozheniy-oktyabrya/',
    date: '10 ноября 2014',
    type: 'press',
  },
  {
    source: 'Эксперт',
    text: 'Кто поделит миллиард',
    link: 'http://expert.ru/expert/2014/46/kto-podelit-milliard/',
    date: '10 ноября 2014',
    type: 'press',
  },
  {
    source: 'Афиша-Воздух',
    text: '«Мы свято верим, что будущее книг, как и музыки, за подпиской»',
    link:
      'http://vozduh.afisha.ru/technology/my-svyato-verim-chto-budushchee-knig-kak-i-muzyki-za-podpiskoy/',
    date: '14 октября 2014',
    type: 'press',
  },
  {
    source: 'Ведомости',
    text: 'Bookmate заговорил по‐английски',
    link:
      'http://www.vedomosti.ru/newspaper/article/770001/cifry-tendencii-sobytie',
    date: '9 октября 2014',
    type: 'press',
  },
  {
    source: 'Lenta.ru',
    text: 'В Bookmate появился крупнейший англоязычный каталог',
    link: 'http://lenta.ru/news/2014/10/09/bookmate',
    date: '9 октября 2014',
    type: 'press',
  },
  {
    source: 'CNews',
    text:
      'В библиотеке Bookmate появился англоязычный каталог книг издательства HarperCollins',
    link: 'http://www.cnews.ru/news/line/index.shtml?2014%2F10%2F09%2F588229',
    date: '9 октября 2014',
    type: 'press',
  },
  {
    source: 'Lenta.ru',
    text: 'Вышло приложение для чтения книг с лентой активности друзей',
    link: 'http://lenta.ru/news/2014/09/30/bookmate/',
    date: '1 октября 2014',
    type: 'press',
  },
  {
    source: 'ItReviewer.ru',
    text:
      'Социальная читалка. Приложение Bookmate позволяет узнать, что читают ваши друзья',
    link:
      'http://itreviewer.ru/news/21338/sotsialnaya-chitalka-prilozhenie-bookmate-pozvolyaet-uznat-chto-chitayut-vashi-druzya/',
    date: '1 октября 2014',
    type: 'press',
  },
  {
    source: 'Секрет фирмы',
    text: '«В цифровом мире книги конкурируют с Angry Birds»',
    link: 'http://www.kommersant.ru/doc/2536226',
    date: '7 августа 2014',
    type: 'press',
  },
  {
    source: 'Лайфхакер',
    text: 'Ваша книжная полка в сети: Bookmate',
    link:
      'http://lifehacker.ru/2011/11/26/vasha-knizhnaya-polka-v-seti-bookmate/',
    date: '25 ноября 2011',
    type: 'press',
  },
]

export const pressEn = [
  {
    source: 'telecompaper',
    text: 'Telenor Bulgaria adds Bookmate e-book service to digital portfolio',
    link:
      'https://www.telecompaper.com/news/telenor-bulgaria-adds-bookmate-e-book-service-to-digital-portfolio--1317886',
    date: 'November 28, 2019',
    type: 'press',
  },
  {
    source: 'telecompaper',
    text: 'Azercell launches Bookmate Plus package',
    link:
      'https://www.telecompaper.com/news/azercell-launches-bookmate-plus-package--1310887',
    date: 'October 4, 2019 ',
    type: 'press',
  },
  {
    source: 'telecompaper',
    text: 'Telenor Serbia offers Bookmate service to customers',
    link:
      'https://www.telecompaper.com/news/telenor-serbia-offers-bookmate-service-to-customers--1300665',
    date: 'July 15, 2019',
    type: 'press',
  },
  {
    source: 'telecompaper',
    text: 'YouSee offers extra benefits for customers of several services',
    link:
      'https://www.telecompaper.com/news/yousee-offers-extra-benefits-for-customers-of-several-services--1299718',
    date: 'July 5, 2019',
    type: 'press',
  },
  {
    img: 'bookriot.png',
    source: 'BOOK RIOT',
    text: '17 of the Best eBook Subscription Services in 2019',
    link:
      'https://bookriot.com/2019/01/24/best-ebook-subscription-services-2019/',
    date: 'January 24, 2019',
    type: 'press',
  },
  {
    source: 'Good e-Reader',
    text: 'Book Mate is expanding into Scandinavia',
    link:
      'https://goodereader.com/blog/e-book-news/book-mate-is-expanding-into-scandinavia',
    date: 'December 5, 2016',
    type: 'press',
  },
  {
    source: 'Telecompaper',
    text: 'Azercell reports growing popularity of Bookmate app',
    link:
      'http://www.telecompaper.com/news/azercell-reports-growing-popularity-of-bookmate-app--1172138',
    date: 'November 16, 2016',
    type: 'press',
  },
  {
    source: 'JakartaGlobe',
    text: 'Social Reading App Bookmate Gets Friendly With Indonesian Authors',
    link:
      'http://jakartaglobe.beritasatu.com/features/social-reading-app-bookmate-gets-friendly-indonesian-authors/',
    date: 'October 11, 2016',
    type: 'press',
  },
  {
    img: 'digital_trends.jpg',
    source: 'Digital Trends',
    text:
      'Which is the best Netflix for books? Scribd vs. Kindle Unlimited vs. Bookmate',
    link: 'https://www.digitaltrends.com/mobile/best-ebook-apps/',
    date: 'June 1, 2016',
    type: 'press',
  },
  {
    source: 'Trend News Agency',
    text:
      'Azercell Telecom’s Bookmate project arouses great interest among subscribers',
    link: 'http://en.trend.az/business/economy/2513413.html',
    date: 'April 1, 2016',
    type: 'press',
  },
  {
    source: 'KillerStartups',
    text: 'Today’s Killer Startup: Bookmate',
    link: 'http://killerstartups.com/startup-reviews/bookmate',
    date: 'December 28, 2015',
    type: 'press',
  },
  {
    source: 'Buchreport',
    text: 'Mobil und hyperlokal',
    link:
      'http://www.buchreport.de/nachrichten/verlage/verlage_nachricht/datum/2015/11/30/mobil-und-hyperlokal.htm',
    date: 'November 30, 2015',
    type: 'press',
  },
  {
    source: 'Publishing Perspectives',
    text: 'Bookmate CEO says "Publishers Killed Oyster"',
    link:
      'http://publishingperspectives.com/2015/09/bookmate-ceo-says-publishers-killed-oyster/',
    date: 'September 23, 2015',
    type: 'press',
  },
  {
    source: 'The Bookseller',
    text: 'Bookmate expands to Indonesia, partners with Indosat',
    link:
      'http://www.thebookseller.com/news/bookmate-expands-indonesia-partners-indosat-309796',
    date: 'August 25, 2015',
    type: 'press',
  },
  {
    source: 'The Jakarta Post',
    text: 'Economy in brief: Indosat, Bookmate offer e-book service',
    link:
      'http://www.thejakartapost.com/news/2015/08/25/economy-brief-indosat-bookmate-offer-e-book-service.html',
    date: 'August 25, 2015',
    type: 'press',
  },
  {
    source: 'Techinasia',
    text: 'Bookmate launches in Indonesia, hopes to Scoop ebook rivals',
    link: 'https://www.techinasia.com/indonesia-ebooks-bookmate-indosat/',
    date: 'August 24, 2015',
    type: 'press',
  },
  {
    source: 'Techinasia',
    text: 'Bookmate brings social ereading to Latin America',
    link:
      'http://latinbusinessdaily.com/stories/510632242-bookmate-brings-social-ereading-to-latin-america',
    date: 'August 9, 2015',
    type: 'press',
  },
  {
    source: 'The Bookseller',
    text: 'More UK publisher deals for Bookmate',
    link: 'http://www.thebookseller.com/news/more-uk-publisher-deals-bookmate',
    date: 'April 14, 2015',
    type: 'press',
  },
  {
    source: 'The Bookseller',
    text: 'Ignoring subscription imperils sales',
    link:
      'http://www.thebookseller.com/news/ignoring-subscription-imperils-sales',
    date: 'April 14, 2015',
    type: 'press',
  },
  {
    source: 'Digital Book World',
    text: 'HarperCollins Expands Subscription Ebook Partnership with Bookmate',
    link:
      'http://www.digitalbookworld.com/2015/harpercollins-expands-subscription-ebook-partnership-with-bookmate/',
    date: 'February 20, 2015',
    type: 'press',
  },
  {
    source: 'Meme Burn',
    text:
      'Should emerging markets take a different approach to battling online piracy?',
    link:
      'http://memeburn.com/2015/02/should-emerging-markets-take-a-different-approach-to-battling-online-piracy/',
    date: 'February 9, 2015',
    type: 'press',
  },
  {
    source: 'Digital Book World',
    text:
      "Bookmate's Simon Dunlop Talks English-Language Expansion & Making Bookmate the Leading Mobile Reading Platform",
    link:
      'http://www.bookbusinessmag.com/article/bookmate-co-founder-simon-dunlop-talks-english-language-expansion-shares-his-plans-make-bookmate-leading-mobile-reading-platform/1',
    date: 'January 21, 2015',
    type: 'press',
  },
  {
    source: 'Asiaone.com',
    text: 'Read new bestsellers for $16 a month',
    link:
      'http://news.asiaone.com/news/singapore/read-new-bestsellers-16-month',
    date: 'December 20, 2014',
    type: 'press',
  },
  {
    source: 'E27',
    text:
      'Subscription-based e-reading app Bookmate launches in Singapore with StarHub partnership',
    link:
      'http://e27.co/subscription-based-e-reading-app-bookmate-launches-singapore-starhub-partnership-20141217/',
    date: 'December 18, 2014',
    type: 'press',
  },
  {
    source: 'CNBC',
    text: 'Bookmate: Aim to innovate the reading experience',
    link: 'http://video.cnbc.com/gallery/?video=3000340086',
    date: 'December 18, 2014',
    type: 'press',
  },
  {
    source: 'Digital Book World',
    text: 'Bookmate Takes Subscription Ebooks to Asia',
    link:
      'http://www.digitalbookworld.com/2014/bookmate-takes-subscription-ebooks-to-asia/',
    date: 'December 17, 2014',
    type: 'press',
  },
  {
    source: 'Today',
    text:
      'Bookmate launches in Singapore with over half a million e-books available',
    link:
      'http://www.todayonline.com/tech/bookmate-launches-singapore-over-half-million-e-books-available',
    date: 'December 17, 2014',
    type: 'press',
  },
  {
    source: 'Techinasia',
    text:
      'Bookmate lets you read unlimited books for a flat monthly fee, launches in Singapore',
    link:
      'https://www.techinasia.com/bookmate-lets-read-unlimited-books-flat-monthly-fee-launches-singapore/',
    date: 'December 17, 2014',
    type: 'press',
  },
  {
    source: 'Yahoo! News Singapore',
    text: 'Bookmate, The Spotify For E-Books, Official Launches In Singapore!',
    link:
      'https://sg.news.yahoo.com/subscription-based-social-reading-comes-063055141.html',
    date: 'December 17, 2014',
    type: 'press',
  },
  {
    source: 'The Digital Reader',
    text: 'HarperCollins Signs Deal With Bookmate – but Not Kindle Unlimited',
    link:
      'http://the-digital-reader.com/2014/10/09/harpercollins-signs-deal-bookmate-kindle-unlimited/#.VDeiKCmSwVm',
    date: 'October 9, 2014',
    type: 'press',
  },
  {
    source: 'Publishing Perspectives',
    text: 'Editorial from Frankfurt: Why We Can’t Afford to Stand Still',
    link:
      'http://publishingperspectives.com/2014/10/editorial-from-frankfurt-why-we-cant-afford-to-stand-still/',
    date: 'October 9, 2014',
    type: 'press',
  },
  {
    source: 'Tech.eu',
    text:
      'World of words: 10 European startups that aim to improve your e-reading experience',
    link: 'http://tech.eu/features/2772/ereading-startups-europe-ebook/',
    date: 'October 3, 2014',
    type: 'press',
  },
  {
    source: 'The Bookseller',
    text: 'Bookmate launches new subscription reading app',
    link:
      'http://www.thebookseller.com/news/bookmate-launches-new-subscription-reading-app',
    date: 'October 2, 2014',
    type: 'press',
  },
  {
    source: 'Digital Book World',
    text: 'Ebook Subscription Service Bookmate Launches iPhone, Android Apps',
    link:
      'http://www.digitalbookworld.com/2014/ebook-subscription-service-bookmate-launches-iphone-android-apps/',
    date: 'September 30, 2014',
    type: 'press',
  },
  {
    source: 'Mobile Choice',
    text: 'The ebook market finds its (mobile) calling',
    link:
      'http://www.mobilechoiceuk.com/Blogs/30584/the-ebook-market-finds-its-mobile-calling.aspx#.VBhLi2S1Z3a',
    date: 'September 1, 2014',
    type: 'press',
  },
  {
    source: 'eBook Magazine',
    text: 'The next chapter for ebooks',
    link: 'http://www.ebookmagazine.co.uk/the-next-chapter-for-ebooks/20145412',
    date: 'August 14, 2014',
    type: 'press',
  },
  {
    source: 'TechCrunch',
    text: 'E-Book Platform Bookmate Secures $3M To Target Emerging World',
    link:
      'http://techcrunch.com/2014/05/23/ebook-platform-bookmate-secures-3m-to-target-emerging-world/',
    date: 'May 23, 2014',
    type: 'press',
  },
  {
    source: 'VentureBeat',
    text:
      'Bookmate takes $3M to bring social-reading love into Turkey, Scandinavia, and Latin America',
    link:
      'http://venturebeat.com/2014/05/23/bookmate-takes-3m-to-bring-social-reading-love-into-turkey-scandinavia-and-latin-america/',
    date: 'May 23, 2014',
    type: 'press',
  },
  {
    source: 'ArcticStartup',
    text: 'As Readmill shuts down FastR tries to pick up migrating readers',
    link:
      'http://www.arcticstartup.com/2014/05/06/as-readmill-shuts-down-fastr-tries-to-pick-up-migrating-readers',
    date: 'May 06, 2014',
    type: 'press',
  },
]

export const pressEs = [
  {
    source: 'Playboy Mexico',
    text: 'El Influencer: Andrew Baev',
    link:
      'https://www.playboy.com.mx/playboy-se-lee/el-influencer-andrew-baev/',
    date: '',
    type: 'press',
  },
  {
    source: "L'ENFER DES ARTS",
    text: 'Bookmate: la app que todo verdadero lector estaba esperando',
    link:
      'https://lenferdesarts.com/2019/05/22/bookmate-la-app-que-todo-verdadero-lector-estaba-esperando/',
    date: 'May 22, 2019',
    type: 'press',
  },
  {
    source: 'EntornoInteligente',
    text:
      'Conoce esta app de lectura que pretende convertirse en la Netflix de los libros',
    link:
      'https://www.entornointeligente.com/conoce-esta-app-de-lectura-que-pretende-convertirse-en-la-netflix-de-los-libros/',
    date: 'March, 2019',
    type: 'press',
  },
  {
    source: '#RunwayMx',
    text: 'Bookmate, la plataforma de eBooks en México',
    link: 'https://runwaymx.com/2019/02/13/bookmate-en-mexico/',
    date: 'February 13, 2019',
  },
  {
    source: 'GATOPARDO',
    text: 'Una app de lectura tan buena como Netflix',
    link: 'https://gatopardo.com/estilo-de-vida/app-de-lectura-bookmate/',
    date: 'February 6, 2019',
  },
  {
    source: 'El Heraldo',
    text: 'Fomentan la lectura nacional',
    link: 'http://www.heraldo.mx/fomentan-la-lectura-nacional/',
    date: 'February 3, 2019',
  },
  {
    source: 'BajoPalabra',
    text: 'Bookmate: app móvil para los amantes de la lectura',
    link:
      'https://bajopalabra.com.mx/bookmate-app-movil-para-los-amantes-de-la-lectura',
    date: 'January 31, 2019',
  },
  {
    source: 'Los Tiempos',
    text:
      'Tigo lanza la aplicación Bookmate, una biblioteca digital con más de 500 mil libros',
    link:
      'http://www.lostiempos.com/diario/actualidad/vida-y-futuro/20151230/tigo-lanza-la-aplicaci%C3%B3n-bookmate-una-biblioteca-digital-con-m%C3%A1s-de-500_327968_728530.html',
    date: 'December 30, 2015',
  },
].concat(pressEn)

export const pressDa = [
  {
    source: 'recordere.dk',
    text: 'YouSee klar med omfattende fordelsprogram',
    link:
      'http://www.recordere.dk/2017/09/yousee-klar-omfattende-fordelsprogram/',
    date: 'September 25, 2017',
  },
  {
    source: 'NORDJYSKE Medier',
    text: 'YouSee vil belønne samlekunder med ekstra fordele',
    link:
      'https://nordjyske.dk/nyheder/yousee-vil-beloenne-samlekunder-med-ekstra-fordele/042cb571-923d-43fb-949f-bccf820d827c',
    date: 'September 25, 2017',
  },
  {
    source: 'BT',
    text: 'YouSee vil belønne samlekunder med ekstra fordele',
    link:
      'https://www.bt.dk/erhverv/yousee-vil-beloenne-samlekunder-med-ekstra-fordele',
    date: 'September 25, 2017',
  },
  {
    source: 'Mobil',
    text: 'Mofibo stopper samarbejde med Telmore — ny bogtjeneste træder til',
    link:
      'https://mobil.nu/tdc-netvaerk/mofibo-stopper-samarbejde-telmore-75621',
    date: 'January 27, 2017',
  },
  {
    source: 'news.dk',
    text: 'Telmore justerer Play-abonnementet',
    link: 'http://news.dk/nyhed/3162887/telmore-justerer-play-abonnementet',
    date: 'January 26, 2017',
  },
].concat(pressEn)

export const pressSr = [
  {
    date: 'July 27, 2022',
    text:
      'Sergej i Goran, mladi pisci iz Crne Gore, među finalistima regionalnog kokursa kreativnog pisanja',
    link:
      'https://www.vijesti.me/vijesti/drustvo/614202/sergej-i-goran-mladi-pisci-iz-crne-gore-medju-finalistima-regionalnog-kokursa-kreativnog-pisanja',
  },
  {
    source: 'Bizniz & Finansije',
    text:
      'Knjige na srpskom jeziku u stranoj aplikaciji: Cela biblioteka u jednom džepu',
    link:
      'http://bif.rs/2017/01/knjige-na-srpskom-jeziku-u-stranoj-aplikaciji-cela-biblioteka-u-jednom-dzepu/',
    date: 'January 2, 2018',
  },
  {
    source: 'Noizz',
    text: 'NOIZZ poklanja šifru za čitanje 850.000 knjiga u elektronskoj formi',
    link:
      'https://noizz.rs/kultura/noizz-poklanja-sifru-za-citanje-850000-knjiga-u-elektronskoj-formi/4z8z4tf',
    date: 'December 27, 2017',
  },
].concat(pressEn)

export const pressTr = [
  {
    source: 'Vatan',
    text: 'Kitap okumayı sevdirecek uygulamalar',
    link:
      'http://www.gazetevatan.com/hasan-genc-1184430-yazar-yazisi-kitap-okumayi-sevdirecek-uygulamalar',
    date: 'July 22, 2018',
  },
].concat(pressEn)

export type PressItem = {
  source: string
  date: string
  link: string
  text: string
}

const press = {
  ru: pressRu,
  es: pressEs,
  da: pressDa,
  sr: pressSr,
  tr: pressTr,
}

export const getPress = (locale: string): PressItem[] =>
  press[locale] || pressEn
